/**
 * Remove the cleared vehicle from the search params and set other parameters accordingly
 */
export function removeVehicleFromSearchParams(vehicleNumber: number, searchParams: VehicleOfferSearchParams) {
  // fall through in this switch is intentional
  switch (vehicleNumber) {
  case 1:
    searchParams.brand = searchParams.brand2;
    searchParams.models = searchParams.models2;
    searchParams.modelVariants = searchParams.modelVariants2;
    // fall through
  case 2:
    searchParams.brand2 = searchParams.brand3;
    searchParams.models2 = searchParams.models3;
    searchParams.modelVariants2 = searchParams.modelVariants3;
    // fall through
  case 3:
    searchParams.brand3 = searchParams.brand4;
    searchParams.models3 = searchParams.models4;
    searchParams.modelVariants3 = searchParams.modelVariants4;
    // fall through
  case 4:
    searchParams.brand4 = searchParams.brand5;
    searchParams.models4 = searchParams.models5;
    searchParams.modelVariants4 = searchParams.modelVariants5;
    // fall through
  case 5:
    searchParams.brand5 = undefined;
    searchParams.models5 = undefined;
    searchParams.modelVariants5 = undefined;
    break;
  default:
    console.error('unknown vehicleNumber');
    break;
  }
}
